export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";